"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _VariancePicker = _interopRequireDefault(require("./VariancePicker"));
var _MediaGallery = _interopRequireDefault(require("./MediaGallery"));
var _Prices = _interopRequireDefault(require("./Prices"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useLocalTheme = _interopRequireDefault(require("../../../../hooks/useLocalTheme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SelectInputsWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
`;
const ProductInfo = _ref => {
  var _handset$brand$;
  let {
    handset,
    handsetIndex
  } = _ref;
  const {
    media
  } = handset;
  const adjustProductInfo = (0, _useLocalTheme.default)('recommendation.adjustProductInfo', false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    id: `recommendation-handset-name`
  }, !adjustProductInfo && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3
  }, handset.productName)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 1,
      md: 2
    },
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_MediaGallery.default, {
    media: media,
    handsetIndex: handsetIndex
  }), /*#__PURE__*/_react.default.createElement(SelectInputsWrapper, null, adjustProductInfo && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6,
      bottom: 4
    }
  }, (handset === null || handset === void 0 ? void 0 : handset.brand) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1,
    weight: 1,
    dataAttributes: {
      'data-test-id': `device-brand-${handsetIndex}`
    },
    noMargin: true
  }, handset === null || handset === void 0 ? void 0 : (_handset$brand$ = handset.brand[0]) === null || _handset$brand$ === void 0 ? void 0 : _handset$brand$.value), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    weight: 3,
    text: handset.productName,
    dataAttributes: {
      'data-test-id': `device-brand-${handsetIndex}`
    }
  })), /*#__PURE__*/_react.default.createElement(_Prices.default, {
    handsetIndex: handsetIndex
  }), /*#__PURE__*/_react.default.createElement(_VariancePicker.default, {
    handset: handset,
    handsetIndex: handsetIndex
  }))));
};
var _default = ProductInfo;
exports.default = _default;